export enum RawEditableState {
  AlwaysTrue = "AlwaysTrue",
  AlwaysFalse = "AlwaysFalse",
}
export enum ContentEditable {
  True = "true",
  False = "false",
  PlainTextOnly = "plaintext-only",
}